<template>
    <div class="container px-1 mx-auto">
        <section class="mb-32 text-gray-800">
            <div class="relative overflow-hidden bg-no-repeat bg-cover" style="background-position: 50%; background-image: url('https://i.natgeofe.com/k/57f627c4-44b3-4dd6-90e1-9762bdfd03f6/deserts-palm_3x2.jpg'); height: 300px;"></div>
            <div class="container px-1 text-gray-800 md:px-12">
                <div class="block px-1 py-10 rounded-lg shadow-lg md:py-6 md:px-6" style="margin-top: -100px; background: hsla(0, 0%, 100%, 0.8); backdrop-filter: blur(30px);">
                    <div class="px-1 rounded-lg">
                        <div class="flex flex-wrap justify-between mb-2">
                            <h2 class="w-full pl-2 text-2xl font-bold lg:w-6/12 sm:w-full md:w-6/12">
                                CUCI OpenData - สะสางดอกเบี้ย
                            </h2> 
                            <div class="max-w-4xl pl-2 mt-1 text-right sm:w-full md:w-1/2 lg:w-1/2">
                                <router-link to="/openDataRibaMain">
                                    <button  class="px-2 py-1 ml-1 font-bold text-white bg-gray-600 rounded btn-sm">
                                        <i class="w-5 h-5 fa-solid fa-home"> </i>
                                    </button>
                                </router-link>
                                <router-link to="/opendataRibaBarChartYear">
                                    <button class="px-2 py-1 ml-1 font-bold text-white rounded btn-sm" :class="reportType === 'year' ? 'bg-green-500' : 'bg-blue-500'">
                                        รายปี
                                    </button>
                                </router-link>
                                <router-link to="/opendataRibaBarChartMonth">
                                    <button  class="px-2 py-1 ml-1 font-bold text-white rounded btn-sm" :class="reportType === 'month' ? 'bg-green-500' : 'bg-blue-500'">
                                        รายเดือน
                                    </button>
                                </router-link>
                            </div>
                        </div>
                        <div class="flex flex-wrap justify-center">
                            <div class="w-full sm:w-full md:w-full lg:w-full xl:w-3/4">
                                <apexchart 
                                    type="bar" 
                                    height="400" 
                                    width="100%" 
                                    :options="barChartOptions" 
                                    :series="barChartSeries">
                                </apexchart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    mounted(){
        this.barChartOptions.subtitle.text = 'ยอดสะสางดอกเบี้ยสะสมรายปี'
    },
    data(){
        return{
            reportType: 'year',
            barChartOptions: {
                subtitle: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 15,
                    offsetY: 5,
                    floating: false,
                    style: {
                        fontSize:  '16px',
                        fontWeight:  'bold',
                        fontFamily:  'Helvetica, Arial, sans-serif',
                        color:  '#9699a2'
                    },
                },
                colors: ['#ffa533'],
                chart: {
                    type: 'bar',
                    // events: {
                    //     click: function(chart, w, e) {
                    //         console.log(chart, w, e)
                    //     }
                    // }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '76%',
                        endingShape: 'rounded',
                        labels:{
                            position: 'top',
                        }
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                xaxis: {
                    categories: [2562, 2663, 2564, 2565, 2566, 2567, 2568],
                },
                yaxis: {
                    title: {
                        text: 'บาท'
                    },
                    //formatter label 1000 to 1,000
                    labels: {
                        formatter: function (val) {
                            return val.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                tooltip: {
                    theme: 'dark',
                    style: {
                        fontSize: '16px',
                        fontFamily: 'Helvetica, Arial, sans-serif'
                    },
                    x: {
                        show: true,
                        formatter: function (val) {
                            return `ปี ${val}`
                        }
                    },
                    y: {
                        formatter: function (val) {
                            return val.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " บาท"
                        },
                        title: {
                            formatter: () => {
                                return `จำนวนเงิน : `;
                            }
                        }
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            position: 'bottom',
                            //set align legend to center
                            horizontalAlign: 'center',
                        },

                    },
                }],
            },
            barChartSeries: [{
                data: [51972.19, 739217.2, 1027847.21, 307427.69, 1080165.97, 1232384.52, 207427.69]
            }]
        }
    },
    methods: {
    changeReportType(type) {
        this.reportType = type;
        this.barChartOptions = {
            ...this.barChartOptions,
            subtitle: {
                ...this.barChartOptions.subtitle,
                text: type == 'year' ? 'ยอดสะสางดอกเบี้ยสะสมรายปี' : 'ยอดสะสางดอกเบี้ยสะสมรายเดือน'
            }
        };
        if(this.reportType == 'year'){
            this.barChartOptions.xaxis.categories = [2562, 2663, 2564, 2565, 2566, 2567, 2568]
            this.barChartSeries = [{
                data: [51972.19, 739217.2, 1027847.21, 307427.69, 1080165.97, 1232384.52, 207427.69]
            }]
        }else{
            this.barChartOptions.xaxis.categories = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
            this.barChartSeries = [{
                data: [51972.19, 739217.2, 1027847.21, 307427.69, 1080165.97, 1232384.52, 207427.69, 51972.19, 739217.2, 1027847.21, 307427.69, 1080165.97]
            }]
        }
    }
}
}
</script>

<style lang="scss" scoped>

</style>